import {
    assignModelOptions,
    CompositeModel,
    ConfigConstants,
    CustomInjector,
    EquipmentModel,
    ModelOptionsLoaderService,
    TextModel,
    ConfigInstanceToken,
} from '@evorait/pace-core';

export class EquipmentConfigurationServiceKeyModel extends CompositeModel {
    public materialNo: TextModel;
    public serialNo: TextModel;
    public hwid: TextModel;
    public frontId: TextModel;
    public qmNum: TextModel;
    public equipmentNo: TextModel;
    public equipment: EquipmentModel;
    public constructor(
        equipmentModel: EquipmentModel,
        notificationNo: string,
        process: ConfigConstants.PROCESS_INDICATOR,
    ) {
        super('EquipmentConfigurationServiceKeyModel');

        const injector = CustomInjector.getInjector();
        const configService = injector.get(ConfigInstanceToken);
        const modelOptionsLoader = injector.get(ModelOptionsLoaderService);

        this.frontId = <TextModel>this.set(new TextModel('FrontId', configService.getUserFrontId()));

        this.materialNo = <TextModel>this.set(new TextModel('Material', equipmentModel.matnr.value));
        modelOptionsLoader.load(this.materialNo, 'GetServiceKey', 'MaterialNumber', process);

        this.materialNo.options = {
            ...this.materialNo.options,
            applicationIdentifier: ConfigConstants.ApplicationIdentifier.ProductIdentifier,
        };

        this.serialNo = <TextModel>this.set(new TextModel('SerialNum', equipmentModel.sernr.value));
        modelOptionsLoader.load(this.serialNo, 'GetServiceKey', 'SerialNumber');
        this.serialNo.options = {
            ...this.serialNo.options,
            applicationIdentifier: ConfigConstants.ApplicationIdentifier.SerialNumber,
        };
        this.hwid = <TextModel>this.set(new TextModel('HardwareId'));
        modelOptionsLoader.load(this.hwid, 'GetServiceKey', 'HWID');
        this.qmNum = <TextModel>this.set(new TextModel('NotificationNo', notificationNo));
        this.resetRequiredOption();
    }

    /**
     * Called from markup to reset 'required' property of input fields based on logic
     * (Material Number AND Serial Number) OR HardwareId ID is the required input
     */
    public resetRequiredOption(): void {
        this.materialNo = assignModelOptions(
            this.materialNo,
            {
                ...this.materialNo.options,
                required: !this.hwid.value,
            },
            this,
        );
        this.serialNo = assignModelOptions(
            this.serialNo,
            {
                ...this.serialNo.options,
                required: !this.hwid.value,
            },
            this,
        );
        this.hwid = assignModelOptions(
            this.hwid,
            {
                ...this.hwid.options,
                required: !this.materialNo.value && !this.serialNo.value,
            },
            this,
        );
        this.materialNo = assignModelOptions(
            this.materialNo,
            {
                ...this.materialNo.options,
                readonly: !this.materialNo.options.required,
            },
            this,
        );
        this.serialNo = assignModelOptions(
            this.serialNo,
            {
                ...this.serialNo.options,
                readonly: !this.serialNo.options.required,
            },
            this,
        );
        this.hwid = assignModelOptions(
            this.hwid,
            {
                ...this.hwid.options,
                readonly: !this.hwid.options.required,
            },
            this,
        );
    }
}
